import type { GetMyCampaignStatusesResponse } from "schema/gen/es/chiikipoint/wallet/v2/service_pb";
import {
  R7_MIYAGI_CAMPAIGN_END_DATE,
  R7_MIYAGI_CAMPAIGN_START_DATE,
} from "../../../config";
import type { TenantWithFeature } from "../../../libs/connect";
import { getIsInTargetCity } from "../../../libs/tenant";

export type R7MiyagiCampaignBannerType =
  | "not-applied" // 未応募バナー
  | "campaign-ended" // キャンペーン終了バナー
  | "applied" // 応募済みバナー
  | "received" // 受領済みバナー
  | "hidden"; // バナー非表示

export function getR7MiyagiCampaignBannerType(
  campaignStatuses: GetMyCampaignStatusesResponse | null,
  currentDate: Date,
  tenant: TenantWithFeature,
  cityAddress: string,
): R7MiyagiCampaignBannerType {
  // キャンペーン期間外の場合は非表示
  if (
    currentDate < R7_MIYAGI_CAMPAIGN_START_DATE ||
    currentDate > R7_MIYAGI_CAMPAIGN_END_DATE
  ) {
    return "hidden";
  }

  // 対象エリア外の場合は非表示
  if (!getIsInTargetCity(tenant, cityAddress)) {
    return "hidden";
  }

  // APIレスポンスがない場合は非表示
  if (!campaignStatuses) {
    return "hidden";
  }

  const { r6Primary, r6Additional, r7OnSignup } = campaignStatuses;

  // r6Primary, r6Additional いずれか一つでも応募したことのある人は受領済みバナー表示
  if (r6Primary?.isApplied || r6Additional?.isApplied) {
    return "received";
  }

  // r7OnSignup に応募したことのある人は応募済みバナー
  if (r7OnSignup?.isApplied) {
    return "applied";
  }

  // r6Primary, r6Additional, r7OnSignup すべてのキャンペーンに応募したことない人
  // ただし、r7OnSignup.isWinLimitReached の場合はキャンペーン終了バナー表示
  if (r7OnSignup?.isWinLimitReached) {
    return "campaign-ended";
  }

  // すべてのキャンペーンに応募したことない人は未応募バナー表示
  return "not-applied";
}
